var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initPredefinedBundle = /* @__PURE__ */ __name(($formEl, $refs) => {
  let scrollContainer = $refs.scrollContainer;
  let gallery = $refs.gallery;
  let init = true;
  if (!scrollContainer) {
    scrollContainer = $formEl.querySelector(`[x-ref="scrollContainer"]`);
  }
  if (!gallery) {
    gallery = $formEl.querySelector(`[x-ref="gallery"]`);
  }
  const bundle_products = [...$formEl.querySelectorAll("[data-product-handle][data-product-id]")]?.map((element) => {
    return {
      element,
      ..._product.getHtmlProduct(element.getAttribute("data-product-handle")),
      variantId: Number(element.getAttribute("data-variant-id"))
    };
  });
  const discount = parseFloat($formEl.getAttribute("data-discount"));
  const settings = utils.JSONParse($formEl.getAttribute("data-settings"));
  const total_price = bundle_products?.reduce((acc, item) => {
    const price = item?.selected_or_first_available_variant?.price ?? 0;
    return acc + price;
  }, 0);
  let final_price = total_price;
  if (discount) {
    final_price = Math.round(total_price * (100 - discount) / 100);
  }
  const gallerySettings = utils.JSONParse(gallery?.getAttribute("data-settings"));
  const thumbnailSettings = utils.JSONParse(
    $refs.thumbnails?.getAttribute("data-settings")
  );
  const handleAddToCart = /* @__PURE__ */ __name(async (action, parent_id, parent_product_id) => {
    const random_id = utils.shortUUID();
    try {
      state.isAdding = true;
      const bundle_products2 = [...$formEl.querySelectorAll("[data-product-handle][data-product-id]")]?.map((element) => ({
        element,
        ..._product.getHtmlProduct(element.getAttribute("data-product-handle")),
        variantId: Number(element.getAttribute("data-variant-id"))
      }));
      const items = bundle_products2?.map((item) => {
        return {
          id: item?.variantId,
          quantity: 1,
          parent_id,
          properties: {
            _p_id_link: random_id,
            _p_required: "true",
            _p_fixed_quantity: "true",
            _predefined_bundle_product: parent_product_id
          }
        };
      });
      items.push({
        id: parent_id,
        quantity: 1,
        properties: {
          _p_id: random_id,
          _final_price: final_price,
          _old_price: total_price
        }
      });
      const data = await _cart.add({
        items
      });
      if (data.cart_error) {
        state.isAdding = false;
        return;
      }
      _stores.modal.setId("modal--cart-drawer");
      state.isAdding = false;
    } catch (error) {
    }
  }, "handleAddToCart");
  const state = window.Alpine.reactive({
    element: $formEl,
    count: 0,
    show_complementary_products: true,
    selected_media_id: null,
    properties: {},
    discount: 0,
    selling_plan_discount_wording: "",
    isAdding: false,
    quantity: 1,
    sibling_handle: "",
    disable_add_to_cart: /* @__PURE__ */ new Set(),
    required_combine_items: [],
    required_combine_quantity: 0,
    upsell_items: /* @__PURE__ */ new Map()
  });
  const scrollToMediaById = /* @__PURE__ */ __name(async (mediaId, no_variant_select = true) => {
    state.selected_media_id = mediaId;
    const image = gallery?.querySelector(`[data-media-id="${mediaId}"]`);
    if (!image) return;
    await utils.delay(5);
    const header = document.querySelector(".header-sections-container");
    const offsetHeight = Math.max(0, header?.getBoundingClientRect()?.bottom ?? 0);
    const imageOffset = utils.getElementPosition(image);
    if (utils.isElementScrollable(scrollContainer)) {
      let scrollSnap = false;
      if (scrollContainer?.classList?.contains("snap-x")) {
        scrollContainer?.classList.remove("snap-x");
        scrollSnap = true;
      }
      utils.scrollToXY(0, image.offsetLeft, image.offsetTop, scrollContainer, () => {
        if (scrollSnap) {
          scrollContainer?.classList.add("snap-x");
        }
      });
    } else {
      utils.scrollToXY(
        0,
        image.offsetLeft,
        imageOffset.top - offsetHeight - +getComputedStyle(gallery).paddingTop.replace("px", "")
      );
    }
  }, "scrollToMediaById");
  if (state) {
    window.Alpine.store("predefined_bundle", {
      state,
      settings,
      scrollToMediaById,
      handleAddToCart
    });
    const predefined_bundle = window.Alpine.store("predefined_bundle");
    window.Alpine.magic("predefined_bundle", () => predefined_bundle);
    window._stores["predefined_bundle"] = predefined_bundle;
  }
  init = false;
  return {
    state,
    settings,
    scrollToMediaById,
    handleAddToCart
  };
}, "initPredefinedBundle");
window._sections["initPredefinedBundle"] = initPredefinedBundle;
